











































































import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { SuperadminOptions } from '@core/interfaces/super-admin';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { superadmin_options } from '@/config/superadmin_options';

interface TenantTemplate {
  id: number;
  name: string;
  type: string;
}

@Component({
  name: 'bpc-super-admin-new-tenant-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-select': Select,
  },
})
export default class SuperAdminNewTenantForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  // @Prop({ type: String, default: '' }) readonly myStrProp: string;
  // @Prop({ type: Object, default() {return {};}}) readonly myObjectProp: MyInterface;

  // DATA
  public formModel: Partial<SuperadminOptions> = {
    name: null,
    alias: null,
    status: 'active',
    domain: null,
    center_type: 'center',
    tenant_template_id: null,
  };

  tenantTemplates: TenantTemplate[] = [];

  // LIFECYCLE
  // created(){}
  mounted() {
    this.getTenantTemplates();
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED

  get selectedType(): string {
    return this.formModel.center_type;
  }

  get tenantTemplateOptions(): object[] {
    return (
      this.tenantTemplates
        ?.filter(item => item.type === this.selectedType)
        ?.map(item => {
          return { text: item.name, value: item.id };
        }) || []
    );
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get newTenantUrl(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('superadmin-options')}/new-tenant`;
  }

  get tenantTemplatesUrl(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('superadmin-options')}/tenant-templates`;
  }

  get fieldsConfig() {
    return superadmin_options;
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }
  // METHODS

  async getTenantTemplates() {
    const result = await this.$bpcApi.get(`${this.tenantTemplatesUrl}`, {}).toPromise();
    this.tenantTemplates = result.data;
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  // WATCHERS
  @Watch('selectedType')
  onChangeSelectedType() {
    this.formModel.tenant_template_id = null;
  }
}
